const zh_CN = {
  title: '单点登录管理',
};
export default zh_CN;
